import { useState, useEffect } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import { Modal, Button } from "react-bootstrap";
import Topnavbar from '../dashboard/topnavbar';
import { useNavigate } from "react-router-dom";
import { baseurladdress } from '../baseurl';
import axios from 'axios';
import Regionlist from './Regionlist';

import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";


export default function Branchlist() {
    let navigate = useNavigate();
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const Swal = require('sweetalert2')
    const [button, setbutton] = useState("Branch");
    const [data, setData] = useState([]);
    const [regionmodel, setregionmodel] = useState(false);

    const [regioncode, setregioncode] = useState("");
    const [regionname, setregionname] = useState("");



    const changeRegions = (event) => {
        setbutton("Region")
    }
    const changeBranch = (event) => {
        setbutton("Branch")
    }

    const handleclick = (event) => {
        if (button == "Branch") {
            //window.location.href = "/AddBranch";
            navigate("/AddBranch");

        }
        else {
            setregionmodel(true);

        }
    }


    const closeregion = (event) => {
        event.preventDefault();
        setregionmodel(false);
    }

    function editBranch(branch_id) {
        navigate("/EditBranch/" + branch_id);
    }

    useEffect(() => {
        const GetAllBranches = () => {

            axios
                .get(baseurladdress + `getallbranches`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then(res => {
                    const datas = res.data.response;
                    console.log("itemss" + datas);
                    const user = datas.map((item, index) => (

                        <tr style={{ textAlign: "center" }} id={"chk" + item.user_id} >

                            <td>{item.branch_code}</td>
                            <td>{item.branch_name}</td>
                            <td>{item.branch_mobile}</td>
                            <td>{item.branch_place}</td>


                            <td >        <div>
                                {(() => {
                                    if (item.branch_status == 1) {
                                        return (
                                            <div>
                                                <span class="badge bg-success" >
                                                    Active
                                                </span>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div>
                                                <span class="badge bg-danger" >
                                                    Inactive
                                                </span>
                                            </div>
                                        );
                                    }
                                })()}
                            </div></td>

                            <td style={{ "textAlign": "center" }}>
                                <a class="inline-block tbnss"
                                     onClick={() => editBranch(item.branch_id)}
                                >
                                    <i class="text-primary fa fa-edit"></i>
                                </a>
                            </td>

                        </tr>
                    ));

                    setData(user);
                })
                .catch(error => {
                    alert(error);
                })
        }
        GetAllBranches();
    }, []);

    //SUBMIT REGION 👇

    const handleSubmit = () => {

        if (regioncode == "") {
            // alert("Please enter Region Code");
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: 'error',
                title: 'Please enter Region Code'
            })
        }
        else if (regionname == "") {
            //alert("Please enter Region Name");
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: 'error',
                title: 'Please enter Region Name'
            })
        }
        else {
            const data = {

                region_code: regioncode,
                region_name: regionname,
                userid: accessuserid
            };


            fetch(
                baseurladdress + `addregion`,
                {
                    method: "POST",

                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            )
                .then((res) => res.json())
                .then((result) => {
                    if (result["status"] === "success") {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 800,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })

                        Toast.fire({
                            icon: 'success',
                            title: 'Region Added Successfully'
                        })

                        //alert("Region added successfully");
                        window.location.reload();
                        setregionmodel(false);
                        setregioncode("");
                        setregionname("");
                    }
                });
        }
    };

    $(function () {
        setTimeout(function () {
            $('#branchlist').DataTable();
        }, 1000);
    });



    return (
        <>
            <Sidennav />
            <Topnavbar />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        {/* /# row */}
                        <section id="main-content">

                            <div class="card">
                                <div class="card-body">
                                    <div class="row mb-2">

                                        <div class="col-sm-12 float-lg-right text-right">
                                            <button
                                                type="button"
                                                class="d-grid gap-2 d-md-flex justify-content-md-end"
                                                className="btn btn-primary"
                                                onClick={handleclick}
                                            >
                                                Add {button}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="default-tab">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" data-toggle="tab" href="#branch" onClick={changeBranch} >Branches</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#region" onClick={changeRegions} >Regions</a>
                                            </li>


                                        </ul>
                                        <div class="tab-content">
                                            <div class="tab-pane fade show active" id="branch" role="tabpanel">
                                                <div className="col-lg-12">
                                                    <div className="card">

                                                        <div className="card-body">
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered table-responsive-sm" id='branchlist'>
                                                                    <thead>
                                                                        <tr>

                                                                            <th style={{ "textAlign": "center" }}>Branch Code</th>
                                                                            <th style={{ "textAlign": "center" }}>Branch Name</th>
                                                                            <th style={{ "textAlign": "center" }}>Contact Number</th>
                                                                            <th style={{ "textAlign": "center" }}>Address</th>
                                                                            <th style={{ "textAlign": "center" }}>Status</th>
                                                                            <th style={{ "textAlign": "center" }}>Edit</th>

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {data}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tab-pane fade" id="region">
                                                <Regionlist />
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>




                            <Modal show={regionmodel} >

                                <Modal.Header>
                                    <h5 >ADD REGION</h5>
                                </Modal.Header>
                                <Modal.Body>
                                    <form encType="multipart/form-data">
                                        <div className="form-group row">
                                            <div className=" col-md-4">
                                                <h6> Code </h6>
                                                <input type="text" class="form-control" onChange={(e) => setregioncode(e.target.value)} required />
                                            </div>
                                            <div className="col-md-8">
                                                <h6>Region name </h6>
                                                <input type="text" class="form-control" onChange={(e) => setregionname(e.target.value)} required />
                                            </div>
                                        </div>
                                        <Modal.Footer>
                                            <button
                                                className="button1 btn btn-success"
                                                type="button"
                                                onClick={() => handleSubmit()}
                                            >
                                                SUBMIT
                                            </button>
                                            <Button
                                                className="button1"
                                                variant="danger"
                                                onClick={closeregion}
                                            >
                                                Cancel
                                            </Button>
                                        </Modal.Footer>
                                    </form>

                                </Modal.Body>

                            </Modal>

                            {/* /# column */}

                        </section>
                    </div>
                </div>
            </div>

        </>

    )
}
